import React from "react";
import { CSVLink } from "react-csv";
import { IconButton, useChangeTooltipMsg } from "@SeemplicityDev/shared";

interface DownloadTableButtonProps {
  csvData: string[][];
  filename: string;
}

const DownloadTableButton: React.FC<DownloadTableButtonProps> = ({
  csvData,
  filename,
}) => {
  const { copyMsg: downloadLabel, setCopyMsg: setDownloadLabel } =
    useChangeTooltipMsg("Download as CSV", "Downloaded!");

  return (
    <CSVLink
      data={csvData}
      filename={filename}
      onClick={() => setDownloadLabel("Downloaded!")}
    >
      <div className="table-download-btn">
        <IconButton
          data-testid="download-table-btn"
          isIcon="seem-icon-download"
          buttonStyle="secondary"
          size="xxs"
          isGhost
          withTooltip={{ content: downloadLabel }}
        />
      </div>
    </CSVLink>
  );
};

export default DownloadTableButton;
